<template>
  <div class="title_box">
    <div class="top" :class="{ bottomLine: hiddenBottomLine }">
      <div class="left_line"></div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="right_more" v-if="isShowMore" @click="lookMore">
      <div class="all_text" :style="{ color: moreTextColor }">
        {{ rightText }}
      </div>
      <img class="all_img" :src="moreIcon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "commone-title",
  props: {
    title: {
      type: String,
      default() {
        return "标题";
      },
    },
    rightText: {
      type: String,
      default() {
        return "查看更多";
      },
    },
    rightColor: {
      type: String,
      default() {
        return "#3377ff";
      },
    },
    isShowMore: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hiddenBottomLine: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    lookMore() {
      console.log("more");
      this.$emit("lookMore");
    },
  },
  computed: {
    moreTextColor: function() {
      if (this.rightColor == "#333333") {
        return this.rightColor;
      }
      return "#3377ff";
    },
    moreIcon: function() {
      if (this.rightColor == "#333333") {
        return require("../assets/home/product_detail/blue_right_icon.png");
      }
      return require("../assets/home/product_detail/blue_right_icon.png");
    },
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  position: relative;
  .top {
    border-bottom: vw(1) #eef0f3 solid;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: vw(30);
    margin: vw(30);
    margin-top: 0;
    .left_line {
      background-color: $theme-color;
      width: vw(8);
      height: vw(31);
      border-radius: vw(4);
    }
    .title {
      margin-left: vw(16);
      color: #333333;
      font-size: vw(30);
      font-weight: 600;
    }
  }
  .bottomLine {
    border-bottom: 0;
  }
  .right_more {
    position: absolute;
    bottom: 0;
    right: vw(30);
    padding-top: vw(30);
    margin-bottom: vw(30);
    display: flex;
    flex-direction: row;
    align-items: center;
    .all_text {
      color: $theme-color;
      font-size: vw(26);
    }
    .all_img {
      margin-left: vw(6);
      width: vw(22);
      height: vw(21);
    }
  }
}
</style>
